import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const NotFoundPage = React.lazy(() => import('modules/core/pages/NotFoundPage'))

// TODO: this module doesn't have a default export for routes so it cannot
//       be used in our current lazy loading strategy.
export const notFoundRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.notFound.path,
      element: (
        <React.Suspense>
          <NotFoundPage />
        </React.Suspense>
      ),
    },
  ]
}
